/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactMemoRequestContactMemo,
  CreateContactMemoRequestContactMemoFromJSON,
  CreateContactMemoRequestContactMemoFromJSONTyped,
  CreateContactMemoRequestContactMemoToJSON
} from './CreateContactMemoRequestContactMemo'

/**
 *
 * @export
 * @interface CreateCompanyMemoRequest
 */
export interface CreateCompanyMemoRequest {
  /**
   *
   * @type {CreateContactMemoRequestContactMemo}
   * @memberof CreateCompanyMemoRequest
   */
  companyMemo?: CreateContactMemoRequestContactMemo
}

export function CreateCompanyMemoRequestFromJSON(json: any): CreateCompanyMemoRequest {
  return CreateCompanyMemoRequestFromJSONTyped(json, false)
}

export function CreateCompanyMemoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateCompanyMemoRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    companyMemo: !exists(json, 'company_memo')
      ? undefined
      : CreateContactMemoRequestContactMemoFromJSON(json['company_memo'])
  }
}

export function CreateCompanyMemoRequestToJSON(value?: CreateCompanyMemoRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    company_memo: CreateContactMemoRequestContactMemoToJSON(value.companyMemo)
  }
}
